<template>
	<v-card
		width = "300"
	>
		<v-expansion-panels>
		    <v-expansion-panel
		      v-for="(item,i) in renderStates"
		      :key="i + reference"
		    >
		      <v-expansion-panel-header>
		       
		      </v-expansion-panel-header>
		      <v-expansion-panel-content>
		       	
		      </v-expansion-panel-content>
		    </v-expansion-panel>
	  </v-expansion-panels>
	</v-card>
</template>
<script type="text/javascript">
	import {mapState} from "vuex"
	export default {
		name : "stateDevices",
		props : ["reference"],
		data : ()=>({

		}),//data
		computed: {
			...mapState('Devices',{
				stateDevices : state => state.states
			
			}),
			renderStates:function(){
				// this.stateDevices;
				return [1]
			},
		},
		methods: {

		},


	};
</script>